var _rect, _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0032 4.66016C9.40519 4.66016 7.29911 6.76624 7.29911 9.36423V11.0011C7.29042 11.5355 7.16292 12.0615 6.92554 12.541L5.8059 14.8023C5.41073 15.6005 5.99142 16.536 6.88203 16.536H11.9494C11.9673 16.5362 11.9852 16.5363 12.0032 16.5363C12.0211 16.5363 12.0391 16.5362 12.057 16.536H17.1253C18.0159 16.536 18.5966 15.6005 18.2014 14.8023L17.063 12.5031C16.8709 12.1151 16.7507 11.6964 16.7073 11.2671V9.36423C16.7073 6.76624 14.6012 4.66016 12.0032 4.66016Z",
    fill: "#262949"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 17,
    r: 2.5,
    fill: "#EA7E68",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnNotification);
export default __webpack_public_path__ + "static/media/icn-notification.66a25341cc3d76443f907ed771966a61.svg";
export { ForwardRef as ReactComponent };